import {
  CalendarIcon,
  LocationMarkerIcon,
  StarIcon,
  HeartIcon,
} from "@heroicons/react/outline";
import { formatEventStart } from "../../utils/formatEventDate";

export default function InfoCards({ event }) {
  const { date, time } = formatEventStart(event.date_start);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card
        icon={<CalendarIcon className="w-5 h-5" />}
        label="FECHA Y HORA"
        value={date + " | " + time}
      />

      <Card
        icon={<LocationMarkerIcon className="w-5 h-5" />}
        label="UBICACIÓN"
        value={event.map_address}
      />

      <Card
        icon={<StarIcon className="w-5 h-5" />}
        label="TIPO DE EVENTO"
        value={event.event_specific_type}
      />

      <Card
        icon={<HeartIcon className="w-5 h-5" />}
        label="CÓDIGO VESTIMENTA"
        value={event.dress_code}
      />
    </div>
  );
}

function Card({ icon, label, value, subValue }) {
  return (
    <div className="bg-[#042018] border text-center border-green-900/30 p-3 rounded-xl hover:border-green-500/30 transition">
      {/* ICON */}
      {/* <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-900/30 text-green-400 mb-4">
        {icon}
      </div> */}

      {/* LABEL */}
      <p className="text-[10px] tracking-widest text-gray-400 uppercase">
        {label}
      </p>

      {/* MAIN VALUE */}
      <p className="mt-1 font-semibold text-white">{value}</p>
    </div>
  );
}
